import {
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useFirebase } from 'react-redux-firebase';
import ProductionLogModal from 'src/components/Order/ProductionLogModal';

const useStyles = makeStyles(theme => ({
  noContent: {
    padding: theme.spacing(2),
    paddingBottom: 0,
    position: 'relative'
  }
}));

function ProductionLogs({ vin }) {
  const classes = useStyles();

  const [productionLogs, setProductionLogs] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setError] = useState();

  const [activeProductionLog, setActiveProductionLog] = useState(false);

  const firebase = useFirebase();

  const fetchProductionLogs = useCallback(async () => {
    setLoading(true);
    setError(undefined);
    const fetchProductionLogs = firebase
      .functions()
      .httpsCallable('fetchProductionLogs');

    await fetchProductionLogs({ vin })
      .then(({ data }) => {
        setProductionLogs(data.data);
        setLoading(false);
      })
      .catch(err => {
        console.log('err message:', err.message);
        setLoading(false);
        setError(err.message);
      });
  }, [vin]);

  useEffect(() => {
    fetchProductionLogs();
  }, [vin]);

  return (
    <>
      {loading && (
        <div className={classes.noContent}>
          <CircularProgress size={24} />
        </div>
      )}
      {!loading && errorMessage && (
        <div className={classes.noContent}>
          <Typography color="error">{errorMessage}</Typography>
        </div>
      )}
      {!loading && (!productionLogs || productionLogs.length === 0) && (
        <div className={classes.noContent}>
          <Typography>No production logs found.</Typography>
        </div>
      )}
      {!loading && productionLogs && (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Insurance</TableCell>
              <TableCell>Claim #</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {productionLogs.map((productionLog, i) => (
              <TableRow key={productionLog.id} selected={i % 2 === 1}>
                <TableCell>
                  {moment
                    .utc(productionLog.created_at)
                    .local()
                    .format('MM/DD/YYYY')}
                </TableCell>
                <TableCell>{productionLog.carrier}</TableCell>
                <TableCell>{productionLog.claim_number}</TableCell>
                <TableCell>
                  <Button
                    color="primary"
                    size="small"
                    onClick={() => setActiveProductionLog(productionLog)}
                  >
                    View
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}

      <ProductionLogModal
        open={Boolean(activeProductionLog)}
        productionLog={activeProductionLog}
        onClose={() => setActiveProductionLog(null)}
      />
    </>
  );
}

ProductionLogs.propTypes = {
  vin: PropTypes.string.isRequired
};

export default ProductionLogs;
